exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xero-connect-button:hover {\n  cursor: pointer; }\n", ""]);

// exports
